export default __webpack_public_path__ + "static/media/4691@2x.4d7aabaa.png";